import { Mail, MessageCircle, Phone } from "lucide-react";
import { NAV_LINKS, WHATSAPP_URL } from "../constants";

export const Footer = ({ onNavigate }) => (
  <footer
        data-testid="site-footer"
        className="relative bg-[#111111] pt-16 pb-8 overflow-hidden"
      >
    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[60rem] h-px bg-gradient-to-r from-transparent via-[#FE7815]/60 to-transparent" />
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid gap-12 lg:grid-cols-[minmax(0,1.35fr)_minmax(0,1fr)_auto] lg:items-start lg:gap-16">
        <div className="max-w-sm min-w-0">
          <img
            src="/movementor-logo-white.png"
            alt="Movementor Education"
            className="h-10 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-6 text-sm text-[#FFFFFF]/55 leading-relaxed">
            Movementor provides personalised study-abroad mentoring, helping
            students make informed education choices and prepare for life
            abroad.
          </p>
          <p className="mt-4 text-sm font-semibold text-[#FFFFFF]/70">
            Dream. Pursue. Become.
          </p>
          <p className="mt-4 text-xs text-[#FFFFFF]/40 italic">
            Vasudhaiva Kutumbakam — the world is one family.
          </p>
          <div className="mt-6 flex flex-col gap-2 text-sm text-[#FFFFFF]/70">
            <a
              href="mailto:hello@movementor.org"
              className="flex items-center gap-2 hover:text-[#FE7815] transition-colors duration-300"
            >
              <Mail className="h-4 w-4 shrink-0" />
              hello@movementor.org
            </a>
            <a
              href="tel:+918136800133"
              className="flex items-center gap-2 hover:text-[#FE7815] transition-colors duration-300"
            >
              <Phone className="h-4 w-4 shrink-0" />
              +91 81368 00133
            </a>
            <a
              href="tel:+918138006133"
              className="flex items-center gap-2 hover:text-[#FE7815] transition-colors duration-300"
            >
              <Phone className="h-4 w-4 shrink-0" />
              +91 81380 06133
            </a>
          </div>
        </div>

        <div className="min-w-0">
          <nav className="grid grid-cols-2 gap-x-8 gap-y-3" data-testid="footer-nav">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => {
                  e.preventDefault();
                  onNavigate(l.href);
                }}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm text-[#FFFFFF]/70 hover:text-[#FE7815] transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#FE7815]">
            Company information
          </p>
          <div className="mt-4 space-y-2 text-sm leading-relaxed text-[#FFFFFF]/70">
            <p>
              <span className="text-[#FFFFFF]/45">Legal name:</span>{" "}
              Movementor Destinations Private Limited
            </p>
            <p>
              <span className="text-[#FFFFFF]/45">CIN:</span>{" "}
              U74999KL2017PTC051239
            </p>
            <p>
              <span className="text-[#FFFFFF]/45">GSTIN:</span>{" "}
              32AALCM4819K1Z8
            </p>
            <p>
              <span className="text-[#FFFFFF]/45">Registered address:</span>{" "}
              Abhcon Axis Complex, 3F1, High Road, 
            </p>

            <p>
              
              South Kuriachira, Thrissur,
              Kerala 680006
            </p>

          </div>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-button"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white px-6 py-3 rounded-full bg-gradient-to-r from-[#FE7815] to-[#F01E1F] hover:-translate-y-0.5 hover:shadow-lg hover:shadow-orange-500/25 transition-[transform,box-shadow] duration-300"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp Us
          </a>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-[#FFFFFF]/40">
          © {new Date().getFullYear()} Movementor Education. All rights
          reserved.
        </p>
        <p className="text-xs text-[#FFFFFF]/40">
          Guiding students since 2017 · Global experience since 2012
        </p>
      </div>
    </div>
  </footer>
);
